import React from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MainAppBar from "../../components/MainAppBar";
import CustomAlert from "../../components/CustomAlert/CustomAlert";

const RequestStripeForToursView = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <MainAppBar
        headerText={t("request_stripe_for_tours.title")}
        showHomeButton={true}
      />
      <Box className={props.classes.mainContent}>
        <Container className={props.classes.formContainer}>
          <Box className={props.classes.headerContainer}>
            <Typography variant="h4" className={props.classes.title}>
              {t("request_stripe_for_tours.title")}
            </Typography>
            <Typography variant="subtitle1" className={props.classes.subtitle}>
              {t("request_stripe_for_tours.subtitle")}
            </Typography>
          </Box>

          <form onSubmit={props.handleSubmit} className={props.classes.form}>
            <FormControl className={props.classes.multiSelect}>
              <InputLabel>
                {t("request_stripe_for_tours.select_tours")}
              </InputLabel>
              <Select
                multiple
                value={props.state.selectedTours}
                onChange={props.handleTourSelection}
                renderValue={(selected) => (
                  <Box>
                    {selected.map((value) => (
                      <Typography key={value} component="span">
                        {
                          props.state.tours.find((tour) => tour.id === value)
                            ?.title
                        }
                        {", "}
                      </Typography>
                    ))}
                  </Box>
                )}
              >
                {props.state.tours.map((tour) => (
                  <MenuItem key={tour.id} value={tour.id}>
                    {tour.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              className={props.classes.input}
              label={t("request_stripe_for_tours.comment")}
              name="comment"
              value={props.state.comment}
              onChange={props.handleInputChange}
              multiline
              rows={4}
            />

            {props.state.showError ? (
              <CustomAlert
                severity="error"
                message={props.state.errorMessage}
                duration={5000}
                onClose={props.resetErrorAlert}
                height={90}
              />
            ) : null}
            {props.state.showSuccess ? (
              <CustomAlert
                severity="success"
                message={props.state.successMessage}
                duration={3000}
                onClose={props.resetSuccessAlert}
                height={90}
              />
            ) : null}

            <Button
              type="submit"
              variant="contained"
              className={props.classes.submitButton}
            >
              {t("request_stripe_for_tours.submit")}
            </Button>
          </form>
        </Container>
      </Box>
    </>
  );
};

export default RequestStripeForToursView;
